// extracted by mini-css-extract-plugin
export default {"inputWrapper":"NumberInput_inputWrapper__crV5R","placeholder":"NumberInput_placeholder__Gqmc3","enlarged":"NumberInput_enlarged__uMv32"};